// PACKAGES
import React, { useState } from 'react'
import { useParams, useLocation, useHistory } from 'react-router-dom'
import { useContext } from 'use-context-selector'
import qs from 'query-string'
// COMPONENTS
import AdditionalStepsDetails from './AdditionalStepsDetails'
import TrackingPixel from '../Utility/TrackingPixel'
// CONTEXTS
import { StepsContext } from '../../contexts/StepsContext'
import { PostingContext } from '../../contexts/PostingContext'
// CONSTS
import { TRACKING_FINISH, TRACKING_SUBMIT } from '../../util/consts'
// HOOKS
import { useMountEffect } from '../../util/hooks'
// SERVICES
import MagicToken from '../../services/magicToken'
import PostingsService from '../../services/postings'

const getPostingData = async (postingId) => {
  const posting = await PostingsService.getPosting(postingId)

  return posting ?? await PostingsService.getAlternativePosting(postingId)
}

const AdditionalStepsReview = () => {
  const [isLoading, setIsLoading] = useState(true)
  const history = useHistory()
  const { search } = useLocation()
  const { token, isNew } = qs.parse(search)
  const { postingId } = useParams()

  const [stepsContext, stepsDispatch] = useContext(StepsContext)
  const [postingState, postingDispatch] = useContext(PostingContext)

  useMountEffect(() => {
    (async () => {
      const jwt = token === undefined ? MagicToken.getJwt() : await MagicToken.retrieveJwt(token)

      const posting = await getPostingData(postingId)
      postingDispatch({ id: 'posting', value: posting })

      const steps = await PostingsService.getApplicantAdditionalSteps(jwt)

      steps.forEach(additionalStep => {
        stepsDispatch({
          id: additionalStep.key,
          value: {
            label: additionalStep.label,
            description: additionalStep.description,
            timeEstimate: additionalStep.timeEstimate,
            isComplete: additionalStep.isComplete,
            version: additionalStep.version
          }
        })
      })

      setIsLoading(false)
      if (token !== undefined) {
        history.replace({
          search: qs.exclude(search, ['token']).toString()
        })
      }
    })()
  })

  const noAdditionalSteps = !Object.keys(stepsContext).length

  return (
    <>
      <AdditionalStepsDetails
        isLoading={isLoading} clientName={postingState.posting?.clientName} url={postingState.posting?.url} postingId={postingId}
      />
      {isNew && noAdditionalSteps && <TrackingPixel eventName={TRACKING_FINISH} />}
      {isNew && <TrackingPixel eventName={TRACKING_SUBMIT} />}
    </>
  )
}

export default AdditionalStepsReview
